// import React, { useEffect, useState } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { Tooltip } from "@mui/material";
// import { useDispatch } from "react-redux";
// import { approveAccessRequest, rejectAccessRequest } from "../../contents/redux/actions/accessRequestActions";
// import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
// import RejectRequestModal from "./RejectRequestModal";
// import styles from "../utilities/cssmodules/AccessRequestsApprovals.module.css";

// const ViewAccessRequestContent = () => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const request = location.state?.request;


//   const [isQueryModalOpen, setIsQueryModalOpen] = useState(false);
//   const [isRejectModalOpen, setIsRejectModalOpen] = useState(false);

//   useEffect(() => {
//   if (request) {
//     console.log("🔍 Access Request Data (Full):");
//     console.dir(request, { depth: null }); // shows nested structure clearly

//     // Or stringify with formatting
//     console.log("🔍 Access Request JSON:", JSON.stringify(request, null, 2));
//   }
// }, [request]);




//   if (!request) {
//     navigate("/accessrequests");
//     return null;
//   };

//   const goBack = () => navigate(-1);

// //   Approval handling
// const handleApproval = () => {
//     if (!request?.id) return;
//     dispatch(approveAccessRequest(request.id)).then(() => {
//         navigate('/accessrequests'); //Go back to access requests after approving
//     });
// };

// //   Rejection handling
// const handleRejection = () => {
//     if (!request?.id) return;
//     dispatch(rejectAccessRequest(request.id)).then(() => {
//         navigate('/accessrequests'); //Go back to access requests after rejecting
//     });
// };


//   return (

//     <div className={styles["component-wrapper"]}>
//         <div className={styles["component-title"]}>
//         <div className={styles["flex-row-container"]}>
//           <div className={styles["flex-row-custom-1"]}>
//             <span className={styles["title-back-button"]} onClick={goBack} aria-label="Go Back">
//               <Tooltip title="Go Back" arrow placement="top">
//                 <ArrowBackIosIcon />
//               </Tooltip>
//             </span>
//             <span>View Access Request</span>
//           </div>
//         </div>
//       </div>

//       <div className={styles["wrapper"]}>
//         <div className={styles["generic_request_content_component_wrapper"]}>
//             <div className={styles["generic_request_content_wrapper"]}>
//                 <div className={styles["request-details-header"]}>
//                     <div className={styles["section-header"]}>
//                         Access Request Details For {request?.companyName}
//                         {/* <p>
//                             View details and perform actions for <b>{request?.companyName}</b>
//                         </p> */}
//                     </div>
//                 </div>
//                 <div className={styles["status-container"]}>
//                     <p>
//                         Status:{" "}
//                         <span className={`${styles["status-badge"]} ${
//                             request?.statusName === "Rejected"
//                             ? styles["status-rejected"]
//                             : request?.statusName === "Submitted"
//                             ? styles["status-submitted"]
//                             : ""
//                         }`}
//                         >
//                         {request?.statusName || "N/A"}
//                         </span>
//                     </p>
//                 </div>




//                 <div className={styles["generic_request_content_container"]}>
//                     <div className={styles["generic_request_content"]}>
//                         <div className={styles["generic_request_content_heading"]}>Company Name:</div>
//                         <div className={styles["generic_request_content_data"]}>{request.companyName || "N/A"}</div>
//                     </div>

//                     <div className={styles["generic_request_content"]}>
//                         <div className={styles["generic_request_content_heading"]}>Business Registration Number:</div>
//                         <div className={styles["generic_request_content_data"]}>{request.businessRegistrationNumber || "N/A"}</div>
//                     </div>

//                     <div className={styles["generic_request_content"]}>
//                         <div className={styles["generic_request_content_heading"]}>Tax Identification Number:</div>
//                         <div className={styles["generic_request_content_data"]}>{request.tin || "N/A"}</div>
//                     </div>

//                     <div className={styles["generic_request_content"]}>
//                         <div className={styles["generic_request_content_heading"]}>Business Address:</div>
//                         <div className={styles["generic_request_content_data"]}>{request.businessAddress || "N/A"}</div>
//                     </div>

//                     <div className={styles["generic_request_content"]}>
//                         <div className={styles["generic_request_content_heading"]}>Admin Fullname:</div>
//                         <div className={styles["generic_request_content_data"]}>{request.contactPerson || "N/A"}</div>
//                     </div>

//                     <div className={styles["generic_request_content"]}>
//                         <div className={styles["generic_request_content_heading"]}>Email:</div>
//                         <div className={styles["generic_request_content_data"]}>{request.email || "N/A"}</div>
//                     </div>

//                     <div className={styles["generic_request_content"]}>
//                         <div className={styles["generic_request_content_heading"]}>Cell Number:</div>
//                         <div className={styles["generic_request_content_data"]}>{request.cellNumber || "N/A"}</div>
//                     </div>

//                     <div className={styles["generic_request_content"]}>
//                         <div className={styles["generic_request_content_heading"]}>Request Date:</div>
//                         <div className={styles["generic_request_content_data"]}>
//                             {request.createdDate
//                                 ? new Date(request.createdDate).toLocaleDateString("en-US", {
//                                     year: "numeric",
//                                     month: "long",
//                                     day: "numeric",
//                                 })
//                             : "N/A"}
//                         </div>
//                     </div>

//                     {request?.statusName === "Submitted" && (
//                         <div className={styles["generic_request_actions_wrapper"]}>
//                             <div className={styles["actions-header"]}></div>
//                             <div className={styles["generic_request_actions"]}>
//                             <button
//                                 className={styles["generic_request_button_primary"]}
//                                 onClick={handleApproval}
//                             >
//                                 Approve
//                             </button>
//                             {/* <button
//                                 className={styles["generic_request_button_secondary"]}
//                                 onClick={() => setIsQueryModalOpen(true)}
//                             >
//                                 Query
//                             </button> */}
//                             <button
//                                 className={styles["generic_request_button_danger"]}
//                                 onClick={handleRejection}
//                             >
//                                 Reject
//                             </button>
//                             {/* <button
//                                 className={styles["generic_request_button_danger"]}
//                                 onClick={() => setIsRejectModalOpen(true)}
//                             >
//                                 Reject
//                             </button> */}
//                             </div>
//                         </div>
//                     )}

//                 </div>
//             </div>
//         </div>
//       </div>

//       <RejectRequestModal
//         isModalVisible={isRejectModalOpen}
//         request={request}
//         onClose={() => setIsRejectModalOpen(false)}
//       />
//     </div>
//   );
// };

// export default ViewAccessRequestContent;































import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Tooltip } from "@mui/material";
import { useDispatch } from "react-redux";
import { approveAccessRequest, rejectAccessRequest } from "../../contents/redux/actions/accessRequestActions";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import RejectAccessRequestModal from "./RejectAccessRequestModal";
import styles from "../utilities/cssmodules/AccessRequestsApprovals.module.css";

const ViewAccessRequestContent = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const request = location.state?.request;

  const [isRejectModalOpen, setIsRejectModalOpen] = useState(false);

  useEffect(() => {
    if (request) {
      console.log("🔍 Access Request Data (Full):");
      console.dir(request, { depth: null });
      console.log("🔍 Access Request JSON:", JSON.stringify(request, null, 2));
    }
  }, [request]);

  if (!request) {
    navigate("/accessrequests");
    return null;
  }

  const goBack = () => navigate(-1);

  // ✅ Approve request
  const handleApproval = () => {
    if (!request?.id) return;
    dispatch(approveAccessRequest(request.id)).then(() => {
      navigate("/accessrequests");
    });
  };

  // ✅ Handle reject submit from modal
  const handleRejectionSubmit = (comment) => {
    if (!request?.id) return;
    dispatch(rejectAccessRequest(request.id, comment)).then(() => {
      setIsRejectModalOpen(false);
      navigate("/accessrequests");
    });
  };

  return (
    <div className={styles["component-wrapper"]}>
      <div className={styles["component-title"]}>
        <div className={styles["flex-row-container"]}>
          <div className={styles["flex-row-custom-1"]}>
            <span className={styles["title-back-button"]} onClick={goBack} aria-label="Go Back">
              <Tooltip title="Go Back" arrow placement="top">
                <ArrowBackIosIcon />
              </Tooltip>
            </span>
            <span>View Access Request</span>
          </div>
        </div>
      </div>

      <div className={styles["wrapper"]}>
        <div className={styles["generic_request_content_component_wrapper"]}>
          <div className={styles["generic_request_content_wrapper"]}>
            <div className={styles["request-details-header"]}>
              <div className={styles["section-header"]}>
                Access Request Details For {request?.companyName}
              </div>
            </div>

            <div className={styles["status-container"]}>
              <p>
                Status:{" "}
                <span
                  className={`${styles["status-badge"]} ${
                    request?.statusName === "Rejected"
                      ? styles["status-rejected"]
                      : request?.statusName === "Submitted"
                      ? styles["status-submitted"]
                      : ""
                  }`}
                >
                  {request?.statusName || "N/A"}
                </span>
              </p>
            </div>

            <div className={styles["generic_request_content_container"]}>
              <div className={styles["generic_request_content"]}>
                <div className={styles["generic_request_content_heading"]}>Company Name:</div>
                <div className={styles["generic_request_content_data"]}>
                  {request.companyName || "N/A"}
                </div>
              </div>

              <div className={styles["generic_request_content"]}>
                <div className={styles["generic_request_content_heading"]}>Business Registration Number:</div>
                <div className={styles["generic_request_content_data"]}>
                  {request.businessRegistrationNumber || "N/A"}
                </div>
              </div>

              <div className={styles["generic_request_content"]}>
                <div className={styles["generic_request_content_heading"]}>Tax Identification Number:</div>
                <div className={styles["generic_request_content_data"]}>
                  {request.tin || "N/A"}
                </div>
              </div>

              <div className={styles["generic_request_content"]}>
                <div className={styles["generic_request_content_heading"]}>Business Address:</div>
                <div className={styles["generic_request_content_data"]}>
                  {request.businessAddress || "N/A"}
                </div>
              </div>

              <div className={styles["generic_request_content"]}>
                <div className={styles["generic_request_content_heading"]}>Admin Fullname:</div>
                <div className={styles["generic_request_content_data"]}>
                  {request.contactPerson || "N/A"}
                </div>
              </div>

              <div className={styles["generic_request_content"]}>
                <div className={styles["generic_request_content_heading"]}>Email:</div>
                <div className={styles["generic_request_content_data"]}>
                  {request.email || "N/A"}
                </div>
              </div>

              <div className={styles["generic_request_content"]}>
                <div className={styles["generic_request_content_heading"]}>Cell Number:</div>
                <div className={styles["generic_request_content_data"]}>
                  {request.cellNumber || "N/A"}
                </div>
              </div>

              <div className={styles["generic_request_content"]}>
                <div className={styles["generic_request_content_heading"]}>Request Date:</div>
                <div className={styles["generic_request_content_data"]}>
                  {request.createdDate
                    ? new Date(request.createdDate).toLocaleDateString("en-US", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      })
                    : "N/A"}
                </div>
              </div>

              {request?.statusName === "Submitted" && (
                <div className={styles["generic_request_actions_wrapper"]}>
                  <div className={styles["actions-header"]}></div>
                  <div className={styles["generic_request_actions"]}>
                    <button
                      className={styles["generic_request_button_primary"]}
                      onClick={handleApproval}
                    >
                      Approve
                    </button>
                    <button
                      className={styles["generic_request_button_danger"]}
                      onClick={() => setIsRejectModalOpen(true)}
                    >
                      Reject
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* ✅ Rejection Modal */}
      <RejectAccessRequestModal
        open={isRejectModalOpen}
        onClose={() => setIsRejectModalOpen(false)}
        onSubmit={handleRejectionSubmit}
        workflowId={request?.workflowId}
        requester={request?.contactPerson}
        requesterId={request?.requesterId}
      />
    </div>
  );
};

export default ViewAccessRequestContent;
